import React from "react";

const MalaysiaSingaporeBusTicket = () => {
  return <div>Malaysia-SingaporeBusTicket</div>;
};

export default MalaysiaSingaporeBusTicket;
